// extracted by mini-css-extract-plugin
export default {"modified":"S7KAnZYPT3ZGo8HrXAsu"};